import qs from "query-string";

const filterNonNull = (obj: any) =>
  obj && Object.fromEntries(Object.entries(obj).filter(([_, v]) => v));

export const apis = {
  search: (query?: {
    keyword: string;
    filters?: string;
    lemma_pos?: string;
    collocate_pos?: string;
    _limit?: number;
    _page?: number;
  }) => ({
    key: "search",
    url: query ? `/words?${qs.stringify(filterNonNull(query))}` : "/words",
  }),
  history: (
    userId: string,
    query?: {
      _limit?: number;
      after?: number;
      before?: number;
      last?: number;
    }
  ) => ({
    key: "history",
    url: query
      ? `/${userId}/histories?${qs.stringify(filterNonNull(query))}`
      : `/${userId}/histories`,
  }),
  oxford: (keyword?: string, lang?: string) => ({
    key: "oxford",
    url:
      lang === "en"
        ? `/oxford/entries/en/${keyword}`
        : `/oxford/translations/en/${lang}/${keyword}`,
  }),
  localSuggestions: (keyword: string) => ({
    key: "localSuggestions",
    url: `/words/suggestion?keyword=${keyword}`,
  }),
  correction: (keyword?: string) => ({
    key: "correction",
    url: `/words/correction?keyword=${keyword}`,
  }),
  allCollocations: (keyword?: string) => ({
    key: "allCollocations",
    url: `/words/lemma?keyword=${keyword}`,
  }),
  ggTranslation: () => ({
    key: "ggTranslation",
    url: "/google/translations",
  }),
  newDictionaries: (keyword?: string) => ({
    key: "new-dict",
    url: `/dictionaryapi/${keyword}`,
  }),
};
